import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { UserModel } from "./user.model";

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<UserModel> = new ReplaySubject<UserModel>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */

    set user(value: UserModel)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<UserModel>
    {
        return this._user.asObservable();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
